module.exports = __webpack_public_path__ + "img/banner1.de5a28e9.png";